import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

store.getPayload = () => {
  const [, payload] = (localStorage.bzToken || '').split('.');
  try {
    return JSON.parse(atob(payload));
  } catch (err) {
    return null;
  }
};

export default store



// WEBPACK FOOTER //
// ./client/store/index.js